import React, { useEffect } from "react";
import "./LNSends.scss";
import Select from "react-select";
import StatisticTable from "../../../../components/StatisticTable/StatisticTable";
import {
  customStylesSelect,
  loaderOverride,
  totalsRanges,
} from "../../../../utils/constants/constants";
import TotalRangePicker from "../../../../components/TotalRangePicker/TotalRangePicker";
import useTableContent from "./hooks/useTableContent";
import { MoonLoader } from "react-spinners";
import useLNSends from "./hooks/useLNSends";
import SendsLegend from "../../../../components/SendsLegend/SendsLegend";
import SendsItem from "../../../../components/SendsItem/SendsItem";

const LNSends = () => {
  const {
    filterTypeSaved,
    fromSaved,
    toSaved,
    fromDate,
    toDate,
    isLoaded,
    selectorValue,
    isLoading,
    data,
    onChain,
    sendCash,
    payments,
    showRangePicker,
    setSelectorValue,
    getLNData,
    setIsLoaded,
    setShowRangePicker,
    getDateRange,
    setFromDate,
    setToDate,
  } = useLNSends();
  const {
    totalTable,
    totalRegularTable,
    totalCashSendsTable,
    totalOnChainTable,
  } = useTableContent(data, onChain, sendCash, payments);

  useEffect(() => {
    if (filterTypeSaved && filterTypeSaved !== "null") {
      setSelectorValue(filterTypeSaved);
      getLNData(fromSaved, toSaved);
    } else if (filterTypeSaved === "null" && fromSaved) {
      setSelectorValue("customized");
      getLNData(fromSaved, toSaved);
    } else {
      getLNData(fromDate, toDate);
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      if (selectorValue === "customized") {
        setSelectorValue("customized");
        return setShowRangePicker(true);
      }

      if (selectorValue) {
        const range = getDateRange(selectorValue);
        getLNData(range.startDate, range.endDate);
      }
    }
  }, [selectorValue]);

  if (isLoading) {
    return (
      <div className="sends__loader">
        <MoonLoader
          color="#7236CD"
          loading={isLoading}
          cssOverride={loaderOverride}
          size={35}
        />
      </div>
    );
  }
  return (
    <div className="sends__wrapper">
      <div className="sends__tables">
        <StatisticTable data={totalTable} />
        <StatisticTable data={totalRegularTable} />
        <StatisticTable data={totalCashSendsTable} />
        <StatisticTable data={totalOnChainTable} />
      </div>
      <div className="sends__selector-wrapper">
        <span className="sends__selector-label">Period</span>
        <Select
          styles={customStylesSelect}
          options={totalsRanges}
          placeholder={"placeholder"}
          getOptionValue={(option) => option.value}
          onChange={(option) => {
            if (
              option.value === "customized" &&
              selectorValue === "customized"
            ) {
              setShowRangePicker(true);
            }

            setSelectorValue(option.value);
          }}
          value={totalsRanges.find((option) => option.value === selectorValue)}
        />
      </div>
      <div className="sends__items-table">
        <SendsLegend />
        {console.log(Object.entries(data)[0])}
        {data
          ? Object.entries(data)
              .sort((a, b) => new Date(a[0]) - new Date(b[0]))
              ?.reverse()
              ?.map((el) => <SendsItem el={el} key={el[0]} />)
          : null}
      </div>
      {showRangePicker && (
        <TotalRangePicker
          showModal={showRangePicker}
          setShowModal={setShowRangePicker}
          getData={getLNData}
          setFromDate={setFromDate}
          setToDate={setToDate}
          fromDate={fromDate}
          toDate={toDate}
        />
      )}
    </div>
  );
};

export default LNSends;
